import { createAction, props } from '@ngrx/store';
import { MailUsers } from 'src/app/commons/models/mail-users.model';

export const dialogOpened = createAction('[Mail Users] Dialog opened', props<{ dialogId: string }>());
export const closeDialog = createAction('[Mail Users] Close detail dialog');

export const sendMail = createAction('[Mail Users] Send mail', props<{ mailUsers: MailUsers }>());
export const sendMailCompleted = createAction('[Mail Users] Send mail completed');
export const sendMailCancelled = createAction('[Mail Users] Send mail cancelled');
export const sendMailFailed = createAction('[Mail Users] Send mail failed', props<{ error: any }>());